import request from '@/plugin/axios'

export function AccountLogin (data) {
  return request({
    url: '/Login',
    method: 'post',
    data
  })
}
